<header *ngIf="!isOem" class="header">
  <div class="arrow-button" onclick="history.back()"></div>
  <h1>
    <img
      class="logo-image"
      [src]="logoUrl"
      width="194"
      height="20"
      alt="Hayfever"
    />
  </h1>
</header>
<div class="container">
  <header
    *ngIf="isOem"
    class="mb-10"
    style="display: flex; justify-content: center"
  >
    <app-hayfever-oem-header [clientId]="clientId"></app-hayfever-oem-header>
  </header>
  <div data-app="true" class="v-application v-application--is-ltr theme--light">
    <div class="v-application--wrap">
      <div class="inner">
        <app-hayfever-oem-login-message [clientId]="clientId" *ngIf="isOem">
        </app-hayfever-oem-login-message>
        <h1>ログイン</h1>
        <div class="text-center mb-10">
          <!-- <img
                  src="/assets/hayfever/images/login_main.svg"
                  width="648"
                  height="400"
                  alt=""
                /> -->
        </div>

        <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
        <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
        <div
          class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
        >
          <div class="v-input__control">
            <div
              class="v-input__slot"
              [ngClass]="errorMessages.login.email ? ['custom-error'] : []"
            >
              <div class="v-text-field__slot">
                <!-- focus時 class="v-label ..." に  を追加 ↓ -->
                <label
                  for="email"
                  [ngClass]="inputLabelClass"
                  class="text-black-38"
                  >メールアドレス</label
                >
                <input
                  (focus)="focus(inputState.email)"
                  (blur)="blur(inputState.email)"
                  [(ngModel)]="email"
                  id="email"
                  type="email"
                />
              </div>
            </div>
            <div class="v-text-field__details">
              <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
              <div class="v-messages theme--light error--text">
                <div
                  *ngIf="errorMessages.login.email"
                  class="v-messages__wrapper"
                >
                  {{ errorMessages.login.email }}

                  <!-- 注釈及びエラーテキストが入ります。 -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
        <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
        <div
          class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
        >
          <div class="v-input__control">
            <div
              class="v-input__slot"
              [ngClass]="errorMessages.login.password ? ['custom-error'] : []"
            >
              <div class="v-text-field__slot">
                <!-- focus時 class="v-label ..." に v-label--active、primary--text を追加 ↓ -->
                <label
                  for="password"
                  [ngClass]="passwordLabelClass"
                  class="text-black-38"
                  >パスワード</label
                >
                <input
                  (focus)="focus(inputState.password)"
                  (blur)="blur(inputState.password)"
                  [(ngModel)]="password"
                  id="password"
                  [type]="passwordToggle.password ? 'text' : 'password'"
                />
              </div>
              <div class="v-input__append-inner">
                <div class="v-input__icon v-input__icon--append">
                  <app-mdi-eye
                    [show]="passwordToggle.password"
                    (click)="passwordToggle.password = !passwordToggle.password"
                  ></app-mdi-eye>
                </div>
              </div>
            </div>
            <div class="v-text-field__details">
              <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
              <div class="v-messages theme--light error--text">
                <div
                  *ngIf="errorMessages.login.password"
                  class="v-messages__wrapper"
                >
                  {{ errorMessages.login.password }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <label class="agreement d-flex align-start mb-5">
          <!-- TODO margin-topじゃない自動レイアウト -->
          <div
            style="margin-top: 5px"
            class="v-input v-input--is-focused theme--light v-input--selection-controls v-input--checkbox"
            (click)="checkIsEmailSave()"
          >
            <div class="v-input__control">
              <div style="height: 32px; align-items: center">
                <div class="v-input--selection-controls__input primary--text">
                  <i aria-hidden="true" [class]="isEmailSaveCheckedStyle.i"></i
                  ><input
                    [(ngModel)]="isSaveEmail"
                    aria-checked="true"
                    id="input-32"
                    role="checkbox"
                    type="checkbox"
                    value=""
                  />
                  <div [class]="isEmailSaveCheckedStyle.div"></div>
                </div>
              </div>
            </div>
          </div>
          <span class="text-gray600">メールアドレスを保存する</span></label
        >

        <div class="text-center mb-5">
          <button
            (click)="login()"
            type="button"
            class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary full-width"
            medium=""
          >
            <span class="v-btn__content"> ログインする </span>
          </button>
        </div>

        <div class="mb-6">
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: baseline;
            "
          >
            <div class="text-center v-text-caption">パスワードをお忘れの方</div>
            <a
              (click)="navigate('forgot-password')"
              class="text-link v-text-caption"
            >
              パスワード再設定
            </a>
          </div>

          <div
            *ngIf="isRegisterResendable"
            style="
              display: flex;
              justify-content: center;
              align-items: baseline;
            "
          >
            <div class="text-center v-text-caption">確認メールが届かない方</div>
            <a
              (click)="navigate('register-resend')"
              class="text-link v-text-caption"
            >
              メール再送信
            </a>
          </div>
          <div
            *ngIf="isRegisterResendable"
            style="
              display: flex;
              justify-content: center;
              align-items: baseline;
            "
          >
            <div class="text-center v-text-caption">
              ログインすることで、当社<a
                [href]="termsUrl"
                target="_blank"
                class="text-link v-text-caption"
              >
                利用規約
              </a>
              に同意したものとみなします。
            </div>
          </div>
        </div>

        <div *ngIf="isRegistable">
          <div class="divider mb-3"></div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: baseline;
            "
          >
            <div class="text-center mb-6 v-text-caption">
              アカウントをお持ちでない方
            </div>
            <button
              (click)="navigate('register')"
              class="btn-lighten-5 v-btn theme--dark"
            >
              <p class="v-text bold">新規登録</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
